import { render, staticRenderFns } from "./baseanswer.vue?vue&type=template&id=1dc71fa6&scoped=true&"
import script from "./baseanswer.vue?vue&type=script&lang=js&"
export * from "./baseanswer.vue?vue&type=script&lang=js&"
import style0 from "./baseanswer.vue?vue&type=style&index=0&id=1dc71fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc71fa6",
  null
  
)

export default component.exports